import { useState } from "react";
import { ApiService } from "@src/shared/api/apiService";
import { API } from "./api";
import { ICandidate } from "@src/shared/types";

export interface ICandidateResult {
  request_uuid: string;
  results: ICandidate[];
}

export const useRequesthResult = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchRequestResult, setSearchRequestResult] = useState<ICandidate[]>(
    []
  );

  const getSearchRequestResult = async (request_uuid: string) => {
    setIsLoading(true);
    try {
      const searchRequestResultRes = await ApiService.get<ICandidateResult>(
        API.GET_REQUEST_RESULTS(request_uuid)
      );

      setSearchRequestResult(searchRequestResultRes.results);
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, getSearchRequestResult, searchRequestResult };
};
